import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IMessage } from 'src/app/models';
import { LiteralService, MessageService } from 'src/app/services';
import { TooltipPosition } from 'src/app/shared/tooltip/tooltip-position';
import { TooltipModule } from 'src/app/shared/tooltip/tooltip.module';

@Component({
  selector: 'app-message-redirect-button',
  templateUrl: './message-redirect-button.component.html',
  imports: [TooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex items-center justify-center' },
})
export class MessageRedirectButtonComponent {
  readonly message = input.required<IMessage>();
  readonly tooltipPosition = input<TooltipPosition>(TooltipPosition.BELOW);
  readonly redirectAction = computed(() =>
    this.messageService.getRedirectTargetAction(this.message().redirectType, this.message().redirectId),
  );
  readonly redirectUrl = computed(() =>
    this.messageService.getRedirectTargetUrl(this.message().redirectType, this.message().redirectId),
  );

  constructor(
    public literalService: LiteralService,
    private messageService: MessageService,
  ) {}

  stopRowSelection(event: Event) {
    event.stopPropagation();
  }
}
